// Phase 4C / Iter91 — In-memory WES Context.
//
// Lifts the latest WES Context envelope built by
// `WESContextBuilderTile` into a shared React in-memory store. The
// envelope holds the FROZEN parity engine's output (VAL/POC/VAH +
// Δ-VAL / Δ-VAH + WES-P / WES-C + ATR for both 1H + D timeframes,
// `evaluator_wes_payload`, `engine_source_fingerprint`) per symbol.
//
// Phase 4C ships ONLY this context + the manual builder tile —
// per-panel wiring into auto-scan payload builders is explicitly
// deferred to a separately authorised phase.
//
// HARD CONSTRAINTS (asserted by Iter91 tests):
//  * In-memory only. The envelope lives only for the lifetime of the
//    React tree. No persistence layer of any kind.
//  * The provider holds no effect hooks — pure state container.
//  * No outbound HTTP from this provider.

import React, { createContext, useContext, useMemo, useState } from "react";

const WESContextContext = createContext({
  wesContext: null,
  request: null,
  setWESContext: () => {},
});

export function WESContextProvider({ children }) {
  const [wesContext, setWESContextState] = useState(null);
  const [request, setRequestState] = useState(null);

  const setWESContext = (nextContext, nextRequest) => {
    setWESContextState(nextContext || null);
    setRequestState(nextRequest || null);
  };

  const value = useMemo(
    () => ({ wesContext, request, setWESContext }),
    [wesContext, request]
  );

  return (
    <WESContextContext.Provider value={value}>
      {children}
    </WESContextContext.Provider>
  );
}

export function useWESContext() {
  return useContext(WESContextContext);
}
